//Core
import React, { useState } from "react"

//styles
import style from "./style.module.scss"

//Images
import logo from "./images/logo.svg"

//Helpers
import { classes } from "../../../helpers/classname"

//Components
import Logo from "./Logo"
import Menu from "./Menu"
import Banking from "./Banking"
import Burger from "./Burger"

const Header = ({ showHeader }) => {
  const [menu, toogleMenu] = useState(false)

  console.log("showHeader_HEADER")
  console.log(showHeader)

  return (
    <>
      <Burger toogleMenu={toogleMenu} menu={menu}></Burger>

      <header
        className={classes(
          style.header,
          menu ? "" : style.open,
          showHeader ? style.show : style.hiddeHeader
        )}
      >
        <Logo logo={logo}></Logo>
        <Menu></Menu>
        <Banking></Banking>
      </header>
    </>
  )
}

export default Header
